import { render } from "./AmexLogo.vue?vue&type=template&id=08597132&scoped=true"
const script = {}

import "./AmexLogo.vue?vue&type=style&index=0&id=08597132&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08597132"]])

export default __exports__